export default angular.module("mars.vet.dnareports.controllers.notes",[]).controller('NotesController', 
        function($rootScope, $scope, $window, 
                EntryService, EntryIDService, ImageService, NavigationService, TranslationService, UtilityService,
                reportdata) {
    'ngInject';

    let resultString = reportdata.resultString;
    let sampleDetails = reportdata.sampleDetails;

    var reportType = 'online';
    $scope.onloadFun = function() {
        reportType = 'pdf';
    }
    
    EntryService.getEntry(EntryIDService.getEntryID('Notes')).then(function(response) {
        var fields = response.fields;
        if (reportType != 'pdf') {
            $rootScope.pageTitle = fields.title;
        }
        $scope.title = fields.title;
        $scope.description = fields.description;
        $scope.translation = TranslationService.getTranslation;
        $scope.couponCode = sampleDetails.couponCode;
        $scope.qaTitle = fields.qaTitle;
        $scope.qaDescription = fields.qaDescription;
        $scope.couponDescription = fields.couponDescription;
        $scope.coupon = fields.coupon;
        $scope.upgradeTitle = fields.upgradeTitle;
        $scope.allowUpgrade = sampleDetails.upgrade;
        let upgradeDescription = fields.upgradeDescription.replace("[PETNAME]", sampleDetails.petDetails.petName);
        $scope.upgradeDescription = upgradeDescription.replace("[LINK]", "<a class='leftnavigationlink' href='https://wisdompanel.com/mdr1_disease_screening', target='_blank'>");
   //     description = fields.description.replaceAll('[LINKREPLACE]', "<a class='leftnavigationlink' href='http://www.wisdompanel.com/breeds' target='_blank'>");

        $scope.noLetterDescription = fields.noLetterDescription;
        $scope.upgradeNowUrl = fields.upgradeNowUrl.replace("<sampleID>", resultString.sampleID);
        $scope.buyNowUrl = fields.buyNowPageUrl;
        var letterFlag = "";
        if (resultString.event !== null && resultString.event !== undefined && resultString.event.length > 0) {
            $scope.pbddDate = UtilityService.formatDate(resultString.event[0]['eventDate']);
            $scope.exceptionDate = UtilityService.formatDate(resultString.event[0]['eventDate']);
        } else {
            $scope.pbddDate = "";
            $scope.exceptionDate = "";
        }
        var resultPbDdBreed = resultString.resultPbDdBreed;
        if (resultPbDdBreed !== undefined && resultPbDdBreed !== null && resultPbDdBreed.length > 0) {
            letterFlag = resultPbDdBreed[0]['type'] == "Wisdom_PB" ? "PB" : resultPbDdBreed[0]['type'] == "Wisdom_DD" ? "DD" : "";
        }
        if (letterFlag == 'PB') {
            $scope.letterTitle = "Purebred Analysis Letter";
            $scope.letterBody = "We have run your test as a Purebred Test and these are our findings.";
        } else if (letterFlag == 'DD') {
            $scope.letterTitle = "First-generation Cross Analysis Letter";
            $scope.letterBody = "We have run your test as a Designer Dog Test and these are our findings.";
        }
        //letterFlag = "";
        $scope.pbddLetterFlag = letterFlag;
        var exceptionLetterFlag = 'false';
    
        if (resultString.event[0] !== null && resultString.event[0] !== undefined &&
            resultString.event[0]['letterflag'] != null && resultString.event[0]['letterflag'] != 'undefined') {
            exceptionLetterFlag = resultString.event[0]['letterflag'];
            var exceptionTitle = "";
            var exceptionDesc = "";
    
            if (exceptionLetterFlag == 'REVISED') {
                exceptionTitle = "We Have Revised Your Report";
                exceptionDesc = "Based on our analysis and conversation we have reviewed and revised your dog’s results accordingly.";
            } else if (exceptionLetterFlag == 'AUTODETAILED') {
                exceptionTitle = "Detailed Refund Analysis";
                exceptionDesc = "Based on our initial analysis we have manually reviewed your results a second time.";
            } else if (exceptionLetterFlag == 'REPEAT') {
                exceptionTitle = "Sample Seen Before";
                exceptionDesc = "Based on our analysis it looks like we have seen a sample of your dog’s DNA before.";
            } else {
                exceptionLetterFlag = 'false';
            }
            //exceptionLetterFlag = 'false';
            $scope.exceptionTitle = exceptionTitle;
            $scope.execeptionBody = exceptionDesc;
        }
        $scope.exceptionLetterFlag = exceptionLetterFlag;
        // use mdr1 image for order upgrade image
        ImageService.getImageUrl("7L4BPe98OIYYoIO4MoyOMU").then(function(response) {
            $scope.upgradeImageUrl = response.data.fields.file.url;
        });

        ImageService.getImageUrl("69OdQqBkgo80I4Ayk22I4I").then(function(response) {
            $scope.exceptionLetterImageUrl = response.data.fields.file.url;
        })
        ImageService.getImageUrl("56Qi9YdKB2mey2GWUasMIK").then(function(response) {
            $scope.pbddLetterImageUrl = response.data.fields.file.url;
        })
        ImageService.getImageUrl("3rONK4UQHekwcsScYS2C0K").then(function(response) {
            $scope.couponCodeImageUrl = response.data.fields.file.url;
        });
        NavigationService.setNavigationUrls();
        $window.ga('send', 'pageview', {
            'page': $rootScope.pageTitle
        });
    }, function(error) {
      // promise rejected, could log the error with:
      // console.log('error', error);
    });
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/notes.controller.js